import { render, staticRenderFns } from "./HoursProjectSelector.vue?vue&type=template&id=2b5b98ed&"
import script from "./HoursProjectSelector.vue?vue&type=script&lang=js&"
export * from "./HoursProjectSelector.vue?vue&type=script&lang=js&"
import style0 from "./HoursProjectSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports